import { CategoryBannerImage } from 'constants/dataTypes';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

interface CategoryBannerImageProps {
  banner: CategoryBannerImage;
  width: number;
}

const CategoryBannerImageComponent: FC<CategoryBannerImageProps> = ({ banner, width }) => {
  const isSmallSquare = banner.bannerType === 'small-square';
  const isMobile = width <= 1140;
  const shouldBeSquare = isMobile || isSmallSquare;
  const imageSrc = isMobile && banner.mobileBannerImage ? banner.mobileBannerImage : banner.desktopBannerImage;
  const imageAlt = isMobile && banner.mobileBannerImageAlt ? banner.mobileBannerImageAlt : banner.desktopBannerImageAlt;

  // Skip large rectangle banners on mobile if no mobile image is provided
  if (!isSmallSquare && isMobile && !banner.mobileBannerImage) {
    return null;
  }

  const wrapperClass = shouldBeSquare 
    ? 'w-full pb-[100%]' // 1:1 aspect ratio
    : 'w-full pb-[33.33%]'; // 3:1 aspect ratio

  const imageContent = (
    <div className={`relative ${wrapperClass} mb-6`}>
      <div className="absolute inset-0 overflow-hidden">
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          className="object-cover"
          sizes={isSmallSquare 
            ? "(max-width: 1140px) 100vw, 33vw" 
            : "100vw"
          }
          priority={true}
        />
      </div>
    </div>
  );

  if (banner.bannerLink) {
    return (
      <Link href={banner.bannerLink} className="block">
        {imageContent}
      </Link>
    );
  }

  return imageContent;
};

export default CategoryBannerImageComponent; 